import ServiceImg from "../images/services/cnc.jpg";

export const ServicesStore = [
  {
    id: "01",
    title: "CNC Milling",
    desc: "3, 4 & 5-axis milling for complex geometries and tight tolerances. We work with aluminum, steel, titanium, and exotic alloys to your exact specifications.",
    img: ServiceImg,
  },
  {
    id: "02",
    title: "CNC Turning",
    desc: "High-speed precision turning with live tooling capabilities. Diameters from 2mm to 500mm, suitable for low-to-high volume production runs.",
    img: ServiceImg,
  },
  {
    id: "03",
    title: "Sheet Metal Fabrication",
    desc: "Laser cutting, precision bending, and MIG/TIG welding for structural and enclosure components in stainless steel, aluminum, and galvanized sheet.",
    img: ServiceImg,
  },
  {
    id: "04",
    title: "Surface Treatment",
    desc: "Anodizing, hard chrome plating, powder coating, and PVD finishing — delivering corrosion resistance and a refined surface quality to full specification.",
    img: ServiceImg,
  },
  {
    id: "05",
    title: "CMM Inspection",
    desc: "Full dimensional verification with coordinate measuring machines. Every batch ships with detailed inspection reports and material certifications.",
    img: ServiceImg,
  },
  {
    id: "06",
    title: "Assembly & Kitting",
    desc: "Sub-assembly, hardware insertion, and kitting services. Ship complete, ready-to-install units directly to your production line with full traceability.",
    img: ServiceImg,
  },
];
